import { render, staticRenderFns } from "./ModalControlUserProfile.vue?vue&type=template&id=46a72963&scoped=true&"
import script from "./ModalControlUserProfile.vue?vue&type=script&lang=js&"
export * from "./ModalControlUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./ModalControlUserProfile.vue?vue&type=style&index=0&id=46a72963&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a72963",
  null
  
)

export default component.exports